import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    message: { type: String, default: "Tem certeza?" },
    title: { type: String, default: "Confirmação" },
    confirmText: { type: String, default: "Sim" },
    cancelText: { type: String, default: "Cancelar" },
    icon: { type: String, default: "warning" }
  }

  // O prefetch de link do Turbo dispara um GET real no mouseenter, sem clique e sem
  // passar por este confirm. Em link que altera estado isso executa a acao sozinho.
  // Turbo so pula o prefetch se o proprio link (ou um ancestral) marcar o opt-out.
  connect() {
    this.element.setAttribute("data-turbo-prefetch", "false")
  }

  confirm(event) {
    // Se já foi confirmado, deixar passar
    if (this.element.dataset.confirmed === "true") {
      this.element.removeAttribute("data-confirmed")
      return
    }

    event.preventDefault()
    event.stopPropagation()

    Swal.fire({
      title: this.titleValue,
      text: this.messageValue,
      icon: this.iconValue,
      showCancelButton: true,
      confirmButtonText: this.confirmTextValue,
      cancelButtonText: this.cancelTextValue
    }).then((result) => {
      if (result.isConfirmed) {
        this._dispatch()
      }
    })
  }

  _dispatch() {
    this.element.dataset.confirmed = "true"
    this.element.click()
  }
}
